import { notification } from './notification';

export const settings = {
  notification,
};
